import { Fragment, useState } from "react";
import { Col } from "reactstrap";
import Experian from "../../../assets/Experian";
import ButtonCommon from "../../../components/ButtonCommon";
import InputCommon from "../../../components/InputCommon";
import CustomAlerts from "../../../components/AlertCustom.js";
import './../index.scss'
import { updateBureauMobile } from '../../../api/onboarding';

const BureauVerification = (props) => {
  const [number, setNumber] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = () => {
    if (number) {
      setLoading(true);
      updateBureauMobile(number).then(res => {
        setLoading(false);
        props.setStep('businessDetail')  
      }).catch(err => {
        setLoading(false);
        CustomAlerts({
          message : err.message,
          title:'Error',
          type:'danger'
        })
      })
    }
  }

  return (
    <Fragment>
      <div className="bureauVerification">
        <Col md={9}>
          <h1>
            Bureau verification
          </h1>
          <h2>
            we need some additional information to verify bureau data. Please answer below questions. <Experian />
          </h2>
          <h2>
            Please enter your mobile number with {props.bureauData?.maskedNumber} format. if you don’t recognize this number, submit without entering mobile number
          </h2>

          <InputCommon value={number} type="number" onChange={(e) => setNumber(e.target.value)}  />
          <ButtonCommon disbabled={loading} title={loading ? "Loading..." : "Submit"} onClick={() => onSubmit()} />
        </Col>
      </div>
    </Fragment>
  )
}

export default BureauVerification;